export const tr = {
    placeholder: 'Ürün adı',
    search: 'bul'
};
